/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { createSlice } from "@reduxjs/toolkit";
import { loginAction, logoutAction } from "./actions";
import { initialAuthenticationState } from './types';

const authSlice = createSlice({
  name: 'auth',
  initialState: initialAuthenticationState,
  reducers: {
    setCredentials: loginAction,
    logout: logoutAction,
  },
});

export const { setCredentials, logout } = authSlice.actions;
export const AuthReducer = authSlice.reducer;
